import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { StyledModalV1 } from "../AttendeesModal/styles";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { ImageUrl } from "../../utils/constants";
import LazyImage from "../common/LazyImage/LazyImage";
import { CustomTitle } from "./styles";
import { TextContainer } from "../ChallengeDetailsV2/WellnessChallenge/styles";
import { CommonButtonBorder } from "../common/commonStyles";

const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  width: 100%;
  justify-content: center;
`;

const BadgeWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const ModalInner = styled.div`
  position: relative;
  padding-top: 88px;
`;

const MonthlyChallengeBadgeModal = ({ showModal, onHide, onShare, challengeAchievement }) => {
  const badge = challengeAchievement?.badge;
  const badgeName = badge?.level_name || "";
  const challengeName = challengeAchievement?.challenge_name || "";
  const hasShared = !!challengeAchievement?.post_id && !!badge;

  return (
    <StyledModalV1
      $width={"550px"}
      $height={"auto !important"}
      show={showModal}
      // style={{ overflow: "visible" }}
      style={{ marginTop: "11%", overflow: "visible" }}
    >
      <ModalInner style={{padding:!badge && '0px'}}>
        {badge && <BadgeWrapper>
          <LazyImage
            style={{ width: "209px", height: "176px",objectFit:'contain' }}
            src={`${ImageUrl}/${badge?.badge_icon}`}
          />
        </BadgeWrapper>}

        <Modal.Header style={{ background: "white", border: "none" }}>
          <CustomTitle isSize={"32px"} style={{ fontWeight: "700" }}>
            <div className="headerContainer">
              <span style={{ marginTop: "4px" }} className="centeredTitle">
                Congratulations!
              </span>
            </div>
          </CustomTitle>
        </Modal.Header>

        <Modal.Body
          style={{
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            padding: "0px 32px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TextContainer isFontSize={"24px"} isLineHeight={"30px"} isFontWeight={"400"} isMargin={"12px 0 0 0"}>You Earned</TextContainer>
          <TextContainer isFontSize={"48px"} isLineHeight={"58px"} isFontWeight={"700"} isTextColor={"#2F6C42"}>{challengeAchievement?.points_earned || 0} XP</TextContainer>
          {badge ? <TextContainer
            isFontSize={"20px"}
            isLineHeight={"28px"}
            isFontWeight={"500"}
            isTextAlign={"center"}
          >
            {`You've earned the `}
            <span style={{ fontWeight: "700" }}>{badgeName} Badge</span>
            {` for completing the `}
            <span >{challengeName}</span>
            {"!"}
          </TextContainer> : <TextContainer style={{textAlign:'center'}} isFontSize={"24px"} isLineHeight={"30px"} isFontWeight={"400"} isMargin={"12px 0 0 0"}>As you have not completed full challenge we are unable to give you the badge better luck next time!</TextContainer> }
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            gap: "12px",
            width: "100%",
            padding: "20px 40px",
          }}
        >
          <FooterButtons>
            {!hasShared && badge && (
              <CommonButtonPopup
                height="40px"
                width="100%"
                onClick={onShare}
              >
                Share Achievement
              </CommonButtonPopup>
            )}
            <CommonButtonBorder height="40px" width="100%" onClick={onHide}>
              Thank You!
            </CommonButtonBorder>
          </FooterButtons>
        </Modal.Footer>
      </ModalInner>
    </StyledModalV1>
  );
};

MonthlyChallengeBadgeModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  challengeAchievement: PropTypes.object,
};

export default MonthlyChallengeBadgeModal;
